import { callGetAPI } from "./API-Calling-service";
const API_URL =  process.env.REACT_APP_CHANGEINITIATION_API_URL + "Division"; //"http://localhost:5009/Division";//process.env.REACT_APP_DIVISION_API_URL
//const axios = require("axios");

export async function getAllDivision() {
  console.log("Inside getAllDivision()");
  return callGetAPI(API_URL);
  // return fetch(API_URL).then((response) => response.json());
}

export async function getEmpdetails(email) {
  console.log("Inside getEmpdetails(email)");
  console.log("email: ",email);
  let url = `${API_URL}/email/${email}`;
  return callGetAPI(url);
  // console.log(url);
  // return fetch(url).then((response) => response.json());
}
